import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import useLoginForm from '../../hooks/Login/useLoginForm';
import { usePinVerification } from '../../context/PinVerificationContext';
import { usePermissionsContext } from '../../context/PermissionsContext';
import ErrorModal from '../Modals/ErrorModal';

const Login = () => {
  const { register, handleSubmit, errors, onSubmit } = useLoginForm();
  const { setUserData } = usePinVerification();
  const { loadPermissions } = usePermissionsContext();
  const navigate = useNavigate();
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleLogin = async (data) => {
    try {
      const result = await onSubmit(data);
      if (result) {
        if (result.user) {
          setUserData(result.user);
        }
        // Recarrega permissões após o login
        await loadPermissions();
        navigate('/home');
        if (!result.user || !result.user.isPin) {
          window.location.reload();
        }
      }
    } catch (error) {
      const errorMessage = error.message || 'Erro desconhecido. Tente novamente.';
      setErrorMessage(errorMessage);
      setShowError(true);
    }
  };

  const handleCloseError = () => setShowError(false);

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Row className="w-100">
        <Col xs={12} md={6} lg={4} className="mx-auto">
          <Form onSubmit={handleSubmit(handleLogin)} className="p-4 shadow rounded bg-white" autoComplete="off">
            <h2 className="text-center mb-4">Login</h2>
            <Form.Group controlId="formUser" className="mb-3">
              <Form.Label>Usuário</Form.Label>
              <Form.Control
                type="text"
                placeholder="Digite seu usuário"
                {...register('username', { required: 'Usuário é obrigatório' })}
                isInvalid={!!errors.username}
                autoComplete="off"
              />
              <Form.Control.Feedback type="invalid">
                {errors.username && errors.username.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formPassword" className="mb-3">
              <Form.Label>Senha</Form.Label>
              <Form.Control
                type="password"
                placeholder="Digite sua senha"
                {...register('password', { required: 'Senha é obrigatória' })}
                isInvalid={!!errors.password}
                autoComplete="off"
              />
              <Form.Control.Feedback type="invalid">
                {errors.password && errors.password.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Button variant="danger" type="submit" className="w-100">
              Entrar
            </Button>
          </Form>

          <ErrorModal
            show={showError}
            handleClose={handleCloseError}
            errorMessage={errorMessage}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Login;